// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupPage_container__2MRD_","tabBarContainer":"GroupPage_tabBarContainer__OUSjT","options":"GroupPage_options__2jAaj"};